module.exports = __webpack_public_path__ + "img/6_19.0a657667.png";